export default "__VITE_ASSET__CESQFhWu__"